import * as React from 'react';

import * as styles from './CountrysideTrapBanner.css';
import { ArrowTopRight } from '../ArrowTopRight';

interface ICountrysideTrapBannerProps {
  villagesLink: string;
  onClick(): void;
}

export function CountrysideTrapBanner({ villagesLink, onClick }: ICountrysideTrapBannerProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['header']}>
        Попробуйте искать&nbsp;
        <a href={villagesLink} onClick={onClick}>
          по посёлкам <ArrowTopRight />
        </a>
      </div>
      <div className={styles['text']}>
        Так вы узнаете больше про застройщика и условия проживания.&nbsp;
        <div className={styles['emoji']} />
      </div>
    </div>
  );
}
